// extracted by mini-css-extract-plugin
module.exports = {"custom":"CustomDeck_custom__ispSA","wrapper":"CustomDeck_wrapper__3ymja"};